module.exports = __webpack_public_path__ + "img/myAccountBtn.ebfddff6.png";